export default "__VITE_ASSET__Dr4xTkC3__"